import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import PropTypes from 'prop-types';
import Dropdown from '../../../../controls/Dropdown';
import BackEnd from '../../../../backend/BackEnd';
import {successToast} from "../../../../utils/toasts";
import ProcessButton from "../../../../controls/ProcessButton";
import MaskedInput from "../../../../controls/MaskedInput";
import {email, phoneNumberRequired, required, validate} from "../../../../utils/validation";
import Fieldset from "../../../../utils/components/Fieldset";

class UserEditModal extends Component {
    static propTypes = {
        userId: PropTypes.number,
        show: PropTypes.bool.isRequired,
        onSave: PropTypes.func.isRequired,
        onHide: PropTypes.func.isRequired
    };
    static defaultProps = {
        userId: null
    };
    state = {
        isLoading: false,
        ...UserEditModal.createFormState()
    };
    fieldUpdateHandle = (event => this.setState({[event.target.name]: event.target.value}));
    getUserFormData = new BackEnd.UsersAdmin.GetUserFormData(this);
    createOrUpdateUser = new BackEnd.UsersAdmin.CreateOrUpdateUser(this);
    formMetadata = {
        phoneNumber: [phoneNumberRequired('Укажите номер телефона')],
        email: [email('Неверный формат адреса Email')],
        roleId: [required('Выберите роль')],
        companyId: [required('Выберите компанию')]
    };

    static createFormState() {
        return {
            phoneNumber: '',
            email: '',
            name: '',
            role: null,
            roleId: 0,
            company: null,
            companyId: 0,
            formState: {}
        }
    }

    async componentWillReceiveProps({userId, show}) {
        if (!show) return;

        if (userId) {
            let formData = await this.getUserFormData.call({userId});
            this.setState(UserEditModal.createFormState(),
                () => this.setState({
                    phoneNumber: formData.phoneNumber
                        ? formData.phoneNumber.substr(2, formData.phoneNumber.length - 2)
                        : formData.phoneNumber,
                    email: formData.email,
                    name: formData.name,
                    role: formData.role,
                    roleId: formData.roleId,
                    company: formData.company,
                    companyId: formData.companyId
                }));
        }
        else {
            this.setState(UserEditModal.createFormState())
        }
    }

    render() {
        const {userId, onSave, ...props} = this.props;
        return (
            <Modal {...props} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>{userId ? 'Редактирование' : 'Создание'} пользователя</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className={this.state.isLoading ? 'form-loading' : ''}>
                        <div className="row">
                            <div className="col-md-6">
                                <Fieldset formState={this.state.formState} fieldName="phoneNumber">
                                    <label className="control-label required"
                                           htmlFor="phoneNumber">Телефон</label>
                                    <div className="input-group">
                                        <div className="input-group-addon">
                                            <span className="flag-icon flag-icon-ru"/> +7
                                        </div>
                                        <MaskedInput type="text" className="form-control"
                                                     name="phoneNumber" id="phoneNumber"
                                                     placeholder="Телефон"
                                                     mask="(999) 999-9999"
                                                     value={this.state.phoneNumber}
                                                     onChange={this.fieldUpdateHandle}/>
                                    </div>
                                </Fieldset>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <Fieldset formState={this.state.formState} fieldName="email">
                                    <label htmlFor="email">Email</label>
                                    <input type="email" className="form-control"
                                           name="email" id="email"
                                           placeholder="Email"
                                           value={this.state.email}
                                           onChange={this.fieldUpdateHandle}/>
                                </Fieldset>
                            </div>
                            <div className="col-md-6">
                                <fieldset className="form-group">
                                    <label htmlFor="name">Имя</label>
                                    <input type="text" className="form-control" name="name" id="name"
                                           placeholder="Имя"
                                           value={this.state.name}
                                           onChange={this.fieldUpdateHandle}/>
                                </fieldset>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <Fieldset formState={this.state.formState} fieldName="roleId">
                                    <label className="control-label required"
                                           htmlFor="roleId">Роль</label>
                                    <Dropdown dataSource={new BackEnd.UsersAdmin.SearchRoles()}
                                              id="roleId" name="roleId"
                                              placeholder="Роль"
                                              item={this.state.role}
                                              value={this.state.roleId}
                                              onChange={event => {
                                                  this.setState({
                                                      roleId: event.target.value,
                                                      company: null,
                                                      companyId: 0
                                                  });
                                              }}/>
                                </Fieldset>
                            </div>
                            <div className="col-md-6">
                                <Fieldset formState={this.state.formState} fieldName="companyId">
                                    <label className="control-label required"
                                           htmlFor="companyId">Компания</label>
                                    <Dropdown dataSource={new BackEnd.UsersAdmin.SearchCompanies()}
                                              requestData={{roleId: this.state.roleId}}
                                              id="companyId" name="companyId"
                                              placeholder="Компания"
                                              disabled={!this.state.roleId}
                                              item={this.state.company}
                                              value={this.state.companyId}
                                              onChange={this.fieldUpdateHandle}/>
                                </Fieldset>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <ProcessButton type="button" className="btn btn-primary"
                                   isLoading={this.state.isLoading}
                                   onClick={() => this.createOrUpdate()}>
                        {userId ? 'Изменить' : 'Создать'}
                    </ProcessButton>
                    <ProcessButton type="button" className="btn btn-default"
                                   isLoading={this.state.isLoading}
                                   onClick={props.onHide}>
                        Закрыть
                    </ProcessButton>
                </Modal.Footer>
            </Modal>
        );
    }

    async createOrUpdate() {
        const {userId, onSave, onHide} = this.props;
        const {
            phoneNumber,
            email,
            name,
            roleId,
            companyId
        } = this.state;

        const {isValid, ...formState} = validate(this.state, this.formMetadata);
        if (!isValid)
            return this.setState({formState});

        const result = await this.createOrUpdateUser.call({
            editUser: {
                id: userId,
                phoneNumber: `7 ${phoneNumber}`,
                email,
                name,
                roleId,
                companyId
            }
        });

        if (result.success) {
            successToast(userId
                ? 'Пользователь успешно изменён'
                : 'Пользователь успешно создан');

            onSave();
            onHide();
        }
    }
}

export default UserEditModal;


// WEBPACK FOOTER //
// ./src/pages/Catalogs/Users/modals/UserEditModal.js